<template>
  <div>
    <loading v-if="loadingImg"></loading>
    <div v-show="!loadingImg" class="big-search">
      <div v-if="loading" class="load-box">
        <van-loading size="24px">加载中...</van-loading>
      </div>
      <div class="wrap" v-if="!loading">
        <div class="search-input">
          <form action="/">
            <van-search :left-icon="searchIcon" v-model="value" :placeholder="placeholder" show-action @cancel="onCancel" @input="linkSearch" id="keyword" @search="enterSearch" />
          </form>
          <!-- <input type="text"  @keyup="tapToSearch"> -->
        </div>
        <div class="link-search" v-if="linkSearchList">
          <div class="list-box" v-if="linkList">
            <div class="list-item" v-for="(item, index) in replaceArr1" :key="index">
              <p @click="TextClick(item)" v-html="item"></p>
              <div @click="TextClick(item)">
                >
              </div>
            </div>
          </div>
        </div>
        <div v-if="noList">
          <!-- 无搜索时 -->
          <div class="no-search" v-if="searchState">
            <!-- 搜索历史 -->
            <div class="search-history" v-if="historyTags.length != 0">
              <div class="search-explain">
                <p>搜索历史</p>
                <div class="search-text" @click="deleteHistory">
                  <van-image :src="deleteIcon" width="13px" height="17px"></van-image>
                  <div>清空</div>
                </div>
              </div>
              <div class="history-tags">
                <span v-for="(item, index) in historyTags" :key="index" @click="chooseHis(item)">
                  {{ item }}
                </span>
              </div>
            </div>
            <!-- 热门搜索 -->
            <div class="popular-search">
              <div class="title-s">
                <p>热门搜索</p>
              </div>
              <div class="popular-tags">
                <span v-for="(item, index) in popularTags" :key="index" @click="choosePopular(item)">{{ item }}</span>
              </div>
            </div>
          </div>
          <!-- 搜索结果 -->
          <div class="yes-search" v-if="!searchState" v-show="ListShow">
            <div class="search-first" v-for="(item, index) in replaceArrList" :key="index" @click="goToDetail(item)">
              <div>
                <van-image :src="item.img" width="35%" height="80px"></van-image>
                <div style="width: 65%;">
                  <div class="lr-box">
                    <div class="lr-text">
                      <p v-html="item.title"></p>
                      <p>{{ $route.query.type ? item.desc : item.name }}</p>
                    </div>
                    <div class="lr-icon">
                      <van-icon name="arrow" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="list">
              <div class="list-item" v-for="(item, index) in replaceArr" :key="index">
                <div v-on:click="goToDetail(item)" class="img-tit">
                  <div class="p-tit" v-html="item.title"></div>
                  <div class="type-tit">
                    {{ $route.query.type ? item.desc : item.name }}
                  </div>
                  <!-- <van-icon name="arrow" class="listarrow" /> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 搜索无数据 -->
        <div class="search-result" v-if="!noList" v-show="!ListShow">
          <div>
            <!-- <van-image :src="noListIcon" width="200px" height="200px"></van-image> -->
            <p>没有找到相关内容，搜索其他试试</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import qs from 'qs';
import Loading from '@/components/loading';
import axios from 'axios'
export default {
  data() {
    return {
      value: '',
      searchVal: '',
      arrReg: [
        {
          name: 'a',
          title: '测试',
        },
        {
          name: 'b',
          title: '公园',
        },
      ],
      deleteIcon: require('../../assets/img/delete_icon.png'),
      searchIcon: require('../../assets/img/bigSearch_icon.png'),
      historyTags: [],
      popularTags: [],
      searchState: true,
      listData: [],
      listData1: [],
      noList: true,
      noListIcon: require('../../assets/img/data_empty.png'), // 搜索无数据
      latitude: '',
      range: '100000',
      longitude: '',
      dataType: this.$route.query.type ? this.$route.query.type : '', //搜索类别
      size: '', //请求数据条数,接口默认10
      //uid: this.$cookie.get('w_uid'),
      uid: '1', //测试id
      name: '',
      title: '',
      coverImge: '',
      titleId: '',
      type: '',
      list_one: '',
      loading: false,
      // 联想搜素
      linkArr: [],
      linkList: true,
      linkSearchList: true,
      dataType1: this.$route.query.type, //搜索类别
      ListShow: false,
      // placeholder: '搜索景区 / 景点',/
      placeholder: '请输入关键字',
      strategy: [],
      line: [],
      strategy1: [],
      line1: [],
      loadingImg: false
    };
  },
  created() {
    // this.linkSearch()
    // if (this.$route.query.type == '6') {
    // 	this.placeholder = '请输入攻略名称';
    // } else if (this.$route.query.type == '7') {
    // 	this.placeholder = '请输入线路名称';
    // } else {
    // 	this.placeholder = '搜索景区 / 景点';
    // }
  },
  mounted() {
    document.title = '搜索';
    // 获取热门搜索标签
    this.getPopularTags();
    // this.showToast()

    if (!this.$route.query.type) {  // 如果type不存在

      if (localStorage.getItem('searchlist') === undefined || localStorage.getItem('searchlist') === null) {  // 缓存数据时
        this.historyTags = [];
      } else {
        this.TagsArr = JSON.parse(localStorage.getItem('searchlist'));
        if (this.TagsArr.length > 9) {
          this.historyTags = this.TagsArr.splice(0, 10);
        } else {
          this.historyTags = this.TagsArr;
        }
      }
    }
    if (this.$route.query.type == 6) {  // 如果是攻略列表进入的话
      if (this.$route.query.judge == 1) {
        if (!localStorage.getItem('searchstrategy')) {
          this.historyTags = [];
        } else {
          this.historyTags = JSON.parse(localStorage.getItem('searchstrategy'));
          if (JSON.parse(localStorage.getItem('searchstrategy')).length > 9) {
            this.historyTags = JSON.parse(
              localStorage.getItem('searchstrategy')
            ).splice(0, 10);
          }
        }
      } else {
        if (!localStorage.getItem('searchstrategy1')) {
          this.historyTags = [];
        } else {
          this.historyTags = JSON.parse(
            localStorage.getItem('searchstrategy1')
          );
          if (JSON.parse(localStorage.getItem('searchstrategy1')).length > 9) {
            this.historyTags = JSON.parse(
              localStorage.getItem('searchstrategy1')
            ).splice(0, 10);
          }
        }
      }
    }
    if (this.$route.query.type == 7) {  // 如果是线路列表进入的话
      if (this.$route.query.judge == 1) {
        if (!localStorage.getItem('searchline')) {
          this.historyTags = [];
        } else {
          this.historyTags = JSON.parse(localStorage.getItem('searchline'));
          if (JSON.parse(localStorage.getItem('searchline')).length > 9) {
            this.historyTags = JSON.parse(
              localStorage.getItem('searchline')
            ).splice(0, 10);
          }
        }
      } else {
        if (!localStorage.getItem('searchline1')) {
          this.historyTags = [];
        } else {
          this.historyTags = JSON.parse(localStorage.getItem('searchline1'));
          if (JSON.parse(localStorage.getItem('searchline1')).length > 9) {
            this.historyTags = JSON.parse(
              localStorage.getItem('searchline1')
            ).splice(0, 10);
          }
        }
      }
    }
  },
  methods: {
    enterSearch() {
      if (this.value) {
        if (!this.$route.query.type) {
          this.onSearch();
        } else {
          this.showToast();
        }
      }
    },
    linkSearch() {
      this.ListShow = false;
      if (this.value === '') {
        this.linkSearchList = false;
        this.noList = false;
      } else {
        this.linkSearchList = true;
        this.noList = true;
      }
      this.$request
        .get(`/appserver/v1/search/relation/list?keyword=${this.value}&dataType=${this.dataType}`)
        .then((data) => {
          if (data.data.ret === 0) {
            this.linkArr = data.data.data ? data.data.data : [];
            if (this.linkArr.length != 0) {
              this.searchState = false;
              this.linkList = true;
            } else {
              this.linkList = false;
            }
          } else {
            this.linkList = false;
            this.searchState = false;
          }
        });
    },
    TextClick(item) {
      this.GetChinese(item);
      if (!this.$route.query.type) {
        this.onSearch();
      } else {
        this.showToast();
      }
    },
    GetChinese(strValue) {
      // eslint-disable-line
      if (strValue !== null && strValue !== '') {
        const reg = /[\u4e00-\u9fa5]/g;
        this.value = strValue.match(reg).join('');
      }
    },
    chooseHis(item) {
      this.value = item;
      if (!this.$route.query.type) {
        this.onSearch();
      } else {
        this.showToast();
      }
    },
    onCancel() {
      if (!this.$route.query.type) {
        this.$router.push({ path: '/' });
      } else {
        this.$router.go(-1);
      }
    },
    InputsSearch() {
      if (this.value == '') {
        // location.reload();
      }
    },
    // 开始搜索
    onSearch() {
      console.log('触发onSearch');
      this.listShow = true;
      if (this.value === '') {
        this.noList = true;
        this.searchState = true;
        return false;
      }
      this.listData = [];
      this.listData1 = [];
      this.loading = true;
      this.loadingImg = true;
      if (!this.$route.query.type) {
        this.$request.get(
          `/appserver/v1/search/by/home/page?size=${this.size}&keyword=${this.value}`,
          {
            headers: {
              latitude: this.latitude, //纬度
              longitude: this.longitude, //经度
            },
          }
        )
          .then((data) => {
            if (data.data.ret === 0) {
              this.loading = false;
              this.loadingImg = false;
              if (!this.$route.query.type) {  // 首页大搜缓存逻辑
                this.historyTags = JSON.parse(localStorage.getItem('searchlist'))? JSON.parse(localStorage.getItem('searchlist')): [];
                if (this.value !== '') {
                  this.historyTags.unshift(this.value);
                }
                for (let i = 0; i < this.historyTags.length; i++) {
                  for (let j = i + 1; j < this.historyTags.length; j++) {
                    if (this.historyTags[i] == this.historyTags[j]) {
                      this.historyTags.splice(j, 1);
                      j--;
                    }
                  }
                }
                localStorage.setItem('searchlist',JSON.stringify(this.historyTags)
                );
              }
              //   console.log(data.data.data.length,'data.data.datadata.data.datadata.data.data')
              if (data.data.data !== null) {
                this.linkSearchList = false;
                if (data.data.data.length !== 0) {
                  this.linkSearchList = false;
                  for (let i in data.data.data) {
                    if (
                      data.data.data[i].type != '4' &&
                      data.data.data[i].type != '6' &&
                      data.data.data[i].type != '10' &&
                      data.data.data[i].type != '11' &&
                      data.data.data[i].type != '12' &&
                      data.data.data[i].type != '15' &&
                      data.data.data[i].type != '16' &&
                      data.data.data[i].type != '17'
                    ) {
                      this.listData.push(data.data.data[i]);
                    }
                  }
                  if (this.listData.length !== 0) {
                    this.ListShow = true
                    this.noList = true;
                    this.listData1 = this.listData.splice(0, 1);
                    this.list_one = this.listData1[0];
                    this.name = this.listData1[0].name;
                    this.title = this.listData1[0].title;
                    this.coverImge = this.listData1[0].img;
                    this.titleId = this.listData1[0].id;
                    this.type = this.listData1[0].type;
                  } else {
                    this.noList = false;
                    this.ListShow = false
                  }
                  this.searchState = false;
                } else {
                  this.searchState = false;
                  this.noList = false;
                  this.ListShow = false;
                }
              }else{
                this.searchState = false;
                  this.noList = false;
                  this.ListShow = false;
              }
            } else {
              this.$toast({
                message: data.data.data,
                duration: '500',
              });
              this.loading = false;
              this.loadingImg = false;
              this.$router.push({
                path: '/bigSearch',
              });
            }
          });
      } else {
        this.showToast();
      }
    },
    showToast() {
      this.loading = true;
      this.loadingImg = true;
      this.searchState = false;
      this.ListShow = true;
      this.$request
        .get(
          `/appserver/v1/search/by/business?${qs.stringify({
            dataType: this.dataType1,
            keyword: this.value,
            scenicId: this.$route.query.id,
          })}`,
          {
            headers: {
              latitude: this.latitude, //纬度
              longitude: this.longitude, //经度
            },
          }
        )
        .then((data) => {
          if (data.data.ret === 0) {
            if (this.$route.query.type == 6) {   // 攻略搜索
              if (this.$route.query.judge == 1) {
                this.strategy = JSON.parse(
                  localStorage.getItem('searchstrategy')
                )
                  ? JSON.parse(localStorage.getItem('searchstrategy'))
                  : [];
                this.strategy.unshift(this.value);
                for (let i = 0; i < this.strategy.length; i++) {
                  for (let j = i + 1; j < this.strategy.length; j++) {
                    if (this.strategy[i] == this.strategy[j]) {
                      this.strategy.splice(j, 1);
                      j--;
                    }
                  }
                }
                localStorage.setItem(
                  'searchstrategy',
                  JSON.stringify(this.strategy)
                );
              } else {
                this.strategy1 = JSON.parse(
                  localStorage.getItem('searchstrategy1')
                )
                  ? JSON.parse(localStorage.getItem('searchstrategy1'))
                  : [];
                this.strategy1.push(this.value);
                for (let i = 0; i < this.strategy1.length; i++) {
                  for (let j = i + 1; j < this.strategy1.length; j++) {
                    if (this.strategy1[i] == this.strategy1[j]) {
                      this.strategy1.splice(j, 1);
                      j--;
                    }
                  }
                }
                localStorage.setItem(
                  'searchstrategy1',
                  JSON.stringify(this.strategy1)
                );
              }
            }
            if (this.$route.query.type == 7) {   // 线路搜索
              if (this.$route.query.judge == 1) {
                this.line = JSON.parse(localStorage.getItem('searchline'))
                  ? JSON.parse(localStorage.getItem('searchline'))
                  : [];
                this.line.unshift(this.value);
                for (let k = 0; k < this.line.length; k++) {
                  for (let l = k + 1; l < this.line.length; l++) {
                    if (this.line[k] == this.line[l]) {
                      this.line.splice(l, 1);
                      l--;
                    }
                  }
                }
                localStorage.setItem('searchline', JSON.stringify(this.line));
              } else {
                this.line1 = JSON.parse(localStorage.getItem('searchline1')) ? JSON.parse(localStorage.getItem('searchline1')) : [];
                this.line1.push(this.value);
                for (let k = 0; k < this.line1.length; k++) {
                  for (let l = k + 1; l < this.line1.length; l++) {
                    if (this.line1[k] == this.line1[l]) {
                      this.line1.splice(l, 1);
                      l--;
                    }
                  }
                }
                localStorage.setItem('searchline1', JSON.stringify(this.line1));
              }
            }
            this.loading = false;
            this.loadingImg = false;
            this.linkSearchList = false;
            this.listData = data.data.data;
            if (this.listData && this.listData.length !== 0) {
              this.listData1 = this.listData.splice(0, 1);
              this.list_one = this.listData1[0];
              this.name = this.listData1[0].desc;
              this.title = this.listData1[0].title;
              this.coverImge = this.listData1[0].img;
              this.titleId = this.listData1[0].id;
              this.type = this.listData1[0].type;
              this.noList = true;
            } else {
              this.ListShow = false;
              this.noList = false;
            }
          }
        });
    },
    //
    unique(arr) {
      return Array.from(new Set(arr));
    },
    //热门搜索
    getPopularTags() {
      axios.create({
        baseURL: this.newUrlHost,
        headers: {},
        withCredentials: true,
      }).get(
        `/appserver/v1/search/hot/list?dataType=${this.dataType}`,
      )
        .then((data) => {
          this.popularTags = data.data.data;
        }).catch(e => { console.log(e, 'eeeeeeeeeeeee') });
    },

    //选择热门搜索
    choosePopular(data) {
      this.value = data;
      this.onSearch();
    },
    //删除历史记录
    deleteHistory() {
      if (this.$route.query.type == 6) {
        if (this.$route.query.judge == 1) {
          localStorage.removeItem('searchstrategy');
        } else {
          localStorage.removeItem('searchstrategy1');
        }
      }
      if (this.$route.query.type == 7) {
        if (this.$route.query.judge == 1) {
          localStorage.removeItem('searchline');
        } else {
          localStorage.removeItem('searchline1');
        }
      }
      if (!this.$route.query.type) {
        localStorage.removeItem('searchlist');
      }
      this.historyTags = [];
    },


    /**
     * 点击进入list详情事件
     */
    goToDetail(item) {
      if (item.type == '1') {    // 绿道名片
        this.$router.push({
          path: '/greenCard',
          query: {
            id: item.id
          },
        });
      } else if (item.type == '2') {   // 攻略详情
        this.$router.push({
          path: '/strategyDetails',
          query: {
            id: item.id
          },
        });
      } else if (item.type == '3' || item.type == '9') {   // 线路
        this.$router.push({
          path: '/lineDetails',
          query: {
            id: item.id
          },
        });
      } else if (item.type == '5') {   //  活动详情
        this.$router.push({
          name: 'activityDetails',
          query: {
            id: item.id
          },
        });
      } else if (item.type == '7') {   // 景区名片
        this.$router.push({
          name: 'scenicParkDetail',
          query: {
            id: item.id
          },
        });
      } else if (item.type == '8') {  // 景点
        this.$router.push({
          name: 'scenicSpot',
          query: {
            id: item.id
          },
        });
      } else if (item.type == '14') {  // 厕所
        // console.log(item,'item')
        // return;
        this.$router.push({
          path: '/findWC',
          query: {
            wcId: item.scenicId,
          },
        });
      } else if (item.type == '13') {  // 停车场
        this.$router.push({
          path: '/parking',
          query: {
            type: 1,  // 测试说不再受限制 工单号 ID1010973
            lat: '',
            lng: '',
          },
        });
      } else {
        this.$toast(`type：${item.type}`)
      }
    },
  },
  computed: {
    replaceArr() {
      const arr = JSON.parse(JSON.stringify(this.listData));
      const searchVal = this.value;
      // 匹配关键字正则
      const replaceReg = new RegExp(searchVal, 'g');
      // 高亮替换v-html值
      const replaceString = `<font color='#2EBA73'>${searchVal}</font>`;
      for (let i = 0; i < arr.length; i++) {
        // 开始替换
        arr[i].title = arr[i].title.replace(replaceReg, replaceString);
      }
      return arr;
    },
    replaceArrList() {
      const arr = JSON.parse(JSON.stringify(this.listData1));
      const searchVal = this.value;
      // 匹配关键字正则
      const replaceReg = new RegExp(searchVal, 'g');
      // 高亮替换v-html值
      const replaceString = `<font color='#2EBA73'>${searchVal}</font>`;
      for (let i = 0; i < arr.length; i++) {
        // 开始替换
        arr[i].title = arr[i].title.replace(replaceReg, replaceString);
      }
      return arr;
    },
    replaceArr1() {
      const arr = JSON.parse(JSON.stringify(this.linkArr));
      const searchVal = this.value;
      // 匹配关键字正则
      const replaceReg = new RegExp(searchVal, 'g');
      // 高亮替换v-html值
      const replaceString = `<strong> <font color='#2EBA73'>${searchVal}</font> </strong>`;
      for (let i = 0; i < arr.length; i++) {
        // 开始替换
        arr[i] = arr[i].replace(replaceReg, replaceString);
      }
      return arr;
    },
  },
  components: {
    Loading
  }
};
</script>
<style lang="scss">
.search-box .search .van-search__content {
  background: #fff;
  padding: 0 10px;
  border: 2px solid rgba(24, 131, 87, 1);
  border-radius: 2px;
  width: 84%;
  height: 35px;
}
</style>
<style lang="scss" scoped>
.big-search {
  .load-box {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .wrap {
    padding-top: 11px;
    .search-input {
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 0px;
      -webkit-user-select: text !important;
      /deep/ .van-search {
        padding: 0;
        width: 96%;
        height: 35px;
      }
      /deep/ .van-search__content {
        background: #fff;
        padding: 0 10px;
        border: 1px solid #2eba73;
        border-radius: 19px;
        width: 84%;
        height: 35px;
        padding-left: 20px;
      }
      /deep/ .van-search .van-cell {
        padding: 5px 0px 8px 0px;
      }
      /deep/ .van-field__left-icon {
        margin-right: 10px;
        // display: none;
      }
      ::-webkit-input-placeholder {
        /* Chrome/Opera/Safari */
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(172, 172, 172, 1);
        line-height: 24px;
      }
      ::-moz-placeholder {
        /* Firefox 19+ */
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(172, 172, 172, 1);
        line-height: 24px;
      }
      :-ms-input-placeholder {
        /* IE 10+ */
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(172, 172, 172, 1);
        line-height: 24px;
      }
      :-moz-placeholder {
        /* Firefox 18- */
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(172, 172, 172, 1);
        line-height: 24px;
      }
      /deep/ .van-field__control {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(85, 89, 89, 1);
      }
      /deep/ .van-icon-clear {
        color: #cecece;
        font-size: 17px;
      }
      .search-cancel {
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(55, 56, 77, 1);
      }
    }
    .link-search {
      padding: 0 20px;
      .list-box {
        .list-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 19px 0px;
          border-bottom: 1px solid #e8e8e8;
          & > p {
            width: 70%;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            font-size: 16px;
            font-weight: bold;
            color: rgba(85, 89, 89, 1);
          }
          & > div {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-size: 18px;
            font-weight: 500;
            color: rgba(153, 153, 153, 1);
            /deep/ .van-image {
              margin-left: 6px;
            }
          }
        }
      }
      .search-result {
        margin-top: 54px;
        display: flex;
        justify-content: center;
        & > div {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          & > p {
            width: 100%;
            text-align: center;
            margin-top: 19px;
            font-size: 13px;
            font-weight: 300;
            color: #787878;
          }
        }
      }
    }
    // 无搜索时
    .no-search {
      padding: 0 20px;
      .search-history {
        margin: 21px 0px 48px 0px;
        .search-explain {
          display: flex;
          justify-content: space-between;
          align-items: center;
          & > p {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 600;
            color: #262626;
            line-height: 16px;
          }
          .search-text {
            display: flex;
            align-items: center;
            div {
              margin-left: 1px;
              color: #bfbfbf;
              font-size: 12px;
            }
          }
        }
        .history-tags {
          & > span {
            display: inline-block;
            min-width: 75px;
            padding: 0 12px;
            text-align: center;
            box-sizing: border-box;
            height: 27px;
            line-height: 27px;
            background: rgba(246, 246, 247, 1);
            border-radius: 14px;
            margin-right: 8px;
            margin-top: 16px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(85, 89, 89, 1);
          }
        }
      }
      .popular-search {
        margin-top: 10px;
        .title-s {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;

          color: rgba(153, 153, 153, 1);
          line-height: 16px;
          p {
            font-weight: 600;
            color: #262626;
          }
        }
        .popular-tags {
          & > span {
            display: inline-block;
            min-width: 75px;
            padding: 0 12px;
            text-align: center;
            box-sizing: border-box;
            height: 27px;
            line-height: 27px;
            background: #f2f2f2;
            border-radius: 14px;
            margin-right: 8px;
            margin-top: 16px;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #787878;
          }
        }
      }
    }
    // 搜索结果
    .yes-search {
      margin-top: 37px;

      .search-first {
        padding: 0 20px;
        & > div {
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 0px 6px 2px rgba(0, 0, 0, 0.05);
          border-radius: 2px;
          padding: 6px 11px 9px 7px;
          display: flex;
          justify-content: flex-start;
        }
        .lr-box {
          margin-left: 15px;
          // width: 50%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .lr-text {
            padding: 15px 0px;
            height: 100%;
            box-sizing: border-box;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            p {
              width: 100%;
              &:nth-of-type(1) {
                font-size: 16px;
                font-weight: 700;
                color: rgba(85, 89, 89, 1);

                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
              }
              &:nth-of-type(2) {
                font-size: 14px;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
              }
            }
          }
          .lr-icon {
            margin-right: 10px;
            /deep/ .van-icon {
              font-size: 20px;
              color: #999;
              font-weight: 700;
            }
          }
        }
      }
      .list {
        margin-top: 30px;
        .list-item {
          padding: 20px;
          border-bottom: 0.5px solid #eeeeee;
          display: flex;
          justify-content: space-between;
          align-items: center;
          min-height: 62px;
          box-sizing: border-box;
          p {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(85, 89, 89, 1);
            &:nth-of-type(2) {
              color: rgba(153, 153, 153, 1);
            }
            margin-right: 10px;
          }

          .img {
            width: 130px;
            height: 80px;
            float: left;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .p-tit {
            font-size: 16px;
            font-weight: bold;
            color: #555959;
            width: 200px;
            overflow: hidden;
            white-space: pre-wrap;
          }
          .type-tit {
            font-size: 16px;
            color: #999999;
            overflow: hidden;
            text-align: right;
          }
          .img-tit {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
        }
      }
    }
    // 搜索无结果
    .search-result {
      margin-top: 200px;
      display: flex;
      justify-content: center;
      & > div {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        & > p {
          width: 100%;
          text-align: center;
          margin-top: 19px;
          font-size: 14px;
          font-weight: 300;
          color: rgba(155, 155, 155, 1);
        }
      }
    }
  }
  .listarrow {
    position: absolute;
    right: 10px;
    font-size: 20px;
    color: #999;
    font-weight: 700;
    top: 40px;
  }
  form {
    width: 100%;
  }
}
</style>
